export const TELEMATICS_DUMMY_GPS_MOBILE_DEVICE_ID = 'virtual_device_id'
